<template>
  <div class="alert alert-danger" role="alert">
    <b>Hinweis an den Autor der Aufgabe:</b>
    {{message}}
  </div>
</template>

<script>
export default {
  name: "generic-alert",
  data() {
    return {
      message: "Unbekannter Fehler..."
    };
  }
};
</script>

<style scoped>
</style>